import { Field } from '@base-ui/react/field';
import classes from "./YuJaTextField.module.css"
import {ReactComponent as ERROR} from "../../images/cross_cricle_red.svg"
import React from "react";
import PropTypes from "prop-types";


export default function YuJaTextField({
                                          value,
                                          maxLength,
                                          placeholder = "",
                                          onChange,
                                          isValid = true,
                                          disabled=false,
                                          errorMsg = "",
                                          size = "small",
                                          description,
                                          before,
                                          after,
                                          containerStyles,
                                          inputStyles,
                                          ...props
                                      }) {

    let sizeClassName;
    if (size === "small") {
        sizeClassName = classes.small;
    } else if (size === "large") {
        sizeClassName = classes.large;
    } else {
        sizeClassName = classes.medium;
    }



    return(
        <Field.Root className={classes.Field} disabled={disabled} invalid={!isValid} style={{...containerStyles}}>
            <div className={`${classes.inputWrapper} ${sizeClassName}`} style={{...inputStyles}}>
                {before}
                <Field.Control
                    value={value ?? ""}
                    onValueChange={onChange}
                    maxLength={maxLength}
                    placeholder={placeholder}
                    {...props}
                />
                {after}
            </div>
            {!!errorMsg &&
                <Field.Error className={classes.Error} match={!isValid}>
                    <ERROR style={{flexShrink: 0}}/> <span>{errorMsg}</span>
                </Field.Error>
            }

            {!!description &&
                <Field.Description className={classes.Description}>
                    {description}
                </Field.Description>
            }
        </Field.Root>
    );
}

YuJaTextField.propTypes = {
    size: PropTypes.oneOf(["small", "medium", "large"]),
}